import { Size } from '@panel/commons/lib/theme/breakpoints';
import { useRef, useEffect, useLayoutEffect, useCallback, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default (callback = () => {}) => {
  const observer = useRef();

  useEffect(() => {
    observer.current = new ResizeObserver(callback);
  }, [callback]);

  return [observer];
};

export const useThemeBreakpoint = () => {
  const [breakPointState, setBreakPointState] = useState();
  const [maxWidth, setMaxwidth] = useState('');

  const checkSize = useCallback(() => {
    const currentWidth = window.innerWidth;
    if (window.innerWidth !== maxWidth) {
      setMaxwidth(currentWidth - 36.5);
    }
    if (currentWidth >= Size.desktop) {
      setBreakPointState('desktop');
    } else if (currentWidth >= Size.tablet && currentWidth < Size.desktop) {
      setBreakPointState('tablet');
    } else {
      setBreakPointState('mobile');
    }
  }, [maxWidth]);

  useLayoutEffect(() => {
    checkSize();
  }, [checkSize, breakPointState]);

  useEffect(() => {
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, [checkSize]);

  return [breakPointState, maxWidth];
};
